import { FC, ReactNode } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion, { AccordionProps } from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import Box from '@mui/material/Box';

type Props = AccordionProps & {
  id: string;
  sortDisabled?: boolean;
  toolbar?: ReactNode;
  title?: ReactNode;
};

const SortableSection: FC<Props> = props => {
  const { id, sortDisabled, children, title, toolbar, ...rest } = props;

  const {
    attributes,
    listeners,
    setActivatorNodeRef,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id, disabled: sortDisabled });

  return (
    <Accordion
      sx={{
        transform: CSS.Transform.toString(transform),
        transition,
      }}
      ref={setNodeRef}
      {...attributes}
      {...rest}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography
          component="div"
          sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
          <Box
            {...listeners}
            ref={setActivatorNodeRef}
            sx={{
              cursor: sortDisabled ? 'auto' : 'row-resize',
              color: sortDisabled ? 'text.disabled' : 'text.primary',
            }}>
            <DragIndicatorIcon
              sx={{ display: 'inline-block', verticalAlign: 'middle' }}
            />
          </Box>
          {title}
        </Typography>

        {toolbar}
      </AccordionSummary>

      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default SortableSection;
